import React, { useState } from "react";
import DecorativeSquares from "../components/ui/DecorativeSquares";
import { useLocation, useNavigate } from "react-router-dom";
import SubscribeTab from "../components/Tab/SubscribeTab";
import { clearOrderDraft } from "../redux/slices/orderDraftSlice";
import { clearSubsOrderDraft } from "../redux/slices/SubscriptionDraftSlice";
import { useDispatch } from "react-redux";
import { FaArrowLeft } from "react-icons/fa";
const AddnewOrder = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const handleGoBack = () => {
    dispatch(clearOrderDraft());
    dispatch(clearSubsOrderDraft());
    if (location.state?.from === "customer") {
      navigate("/customer");
    } else {
      navigate("/order");
    }
  };
  return (
    <>
      <section className="relative max-w-7xl mx-auto  py-6">
        <DecorativeSquares />
        <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
          <button
            onClick={handleGoBack}
            className="flex items-center p-2 rounded-full hover:bg-gray-100"
          >
            <FaArrowLeft size={20} />
          </button>

          <h1 className="mx-auto text-2xl font-semibold text-gray-900">
            Add New Order
          </h1>
        </div>
        <div className="px-0 md:px-4 mt-8">
          <div className="mx-auto w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-4 md:p-6 shadow-sm">
            <div className="flex flex-col">
              <SubscribeTab />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AddnewOrder;
